import type { CartKeys } from '@/store/types/cart'
// we can add logic here to handle the other arrays like promo..
export const getCartType = (po: string | null): CartKeys => {
  if (!po) return 'otp'
  if (po === 'one-time-purchase' || po === 'otp') return 'otp'

  return 'subscribe'
}
